import{$each}from"@olmokit/dom/$each";/**
 * Get timezone offset (in minutes)
 *
 * @see https://usefulangle.com/post/31/detect-user-browser-timezone-name-in-php
 * @return {number}
 */export function getTimezoneOffset(){let minutesOffset=new Date().getTimezoneOffset();// timezone difference in minutes such as 330 or -360 or 0
return 0==minutesOffset?0:-minutesOffset}export function setTimezone(selector="[data-auth-timezone-offset]"){let timezoneOffset=getTimezoneOffset();$each(selector,$input=>{$input.value=timezoneOffset+""})}// auto init?
// setTimezone();
